const URL = process.env.NEXT_PUBLIC_API_BASE
const routes = {
  BASE: URL,
  AUTH: URL + '/api/auth/',
  LOGIN: URL + '/api/auth/login',
  REGISTER: URL + '/api/auth/register',
  COURSE: URL + '/api/education/courses/',
  LIBRARY: URL + '/api/library',
  USER: URL + '/api/users/user',
  STUDENT_ANALYTICS: URL + '/api/analytics',
  REWARD_LEVEL: URL + '/api/users/reward-level',
  NOTIFICATIONS: URL + '/api/users/notification',
  USER_GIFT_CARDS: URL + '/api/users/user/gift-cards',
  AUTHOR: URL + '/api/users/author',
  AUTHOR_COURSES: URL + '/api/users/author/courses/',
  AUTHOR_PUBLIC_FILE_URL: URL + '/api/users/author/public-file-url',
  AUTHOR_INTRODUCTION_VIDEO: URL + '/api/users/author/introduction-video',
  PAYMENTS: URL + '/api/ecommerce/payments',
  CHECKOUT: URL + '/api/ecommerce/payments/checkout',
  USER_CART: URL + '/api/users/user/cart',
  REFERRAL: URL + '/api/users/referral',
  REFERRAL_STATISTICS: URL + '/api/statistics/referral-stats',
  MARKETING: URL + '/api/users/marketing',
  USERNAME: URL + '/api/users/user/username',
  USER_WISHLIST: URL + '/api/users/user/wishlist',
  MY_COURSES: URL + '/api/users/user/my-courses',
  USER_SAVED_ITEMS: URL + '/api/users/user/saved-items',
  CATEGORIES: URL + '/api/categories',
  COURSES: URL + '/api/education/courses',
  ORDERS: URL + '/api/ecommerce/orders',
  GIFTING: URL + '/api/ecommerce/gifting',
  ECOMMERCE: URL + '/api/ecommerce',
  SETTINGS: URL + '/api/moderation/settings',
  REVIEWRECORDS: URL + '/api/moderation/review-records',
  GLOBAL_DISCOUNTS: URL + '/api/moderation/pricing-policies',
  SENDOTP: URL + '/api/',
  VERIFYOTP: URL + '/api/',
  USER_STATS: URL + '/api/statistics/users',
  COURSE_STATS: URL + '/api/statistics/courses',
  PURCHASE_RECORDS: URL + '/api/statistics/purchase-records',
  REVIEWS_STATS: URL + '/api/statistics/reviews',
  STATISTICS: URL + '/api/statistics',
  ANALYTICS: URL + '/api/analytics',
  SEARCH: URL + '/api/search',
  SUPPORT: URL + '/api/support',
}
export default routes
